var ShuttleListItem;

import AccessPopover from 'trunks/vue/admin/compositions/organizations/responses/add_members_modals/access_popover.js';

export default ShuttleListItem = Vue.extend({
  components: {
    'access-popover': AccessPopover
  },
  props: {
    admin: {
      type: Object,
      required: true
    },
    access: {
      type: Object,
      required: true
    },
    accessesList: {
      type: Array,
      required: true
    }
  },
  template: `<div class="shuttle-list-item justify-between">
  <div class="justify-box details-box">
    <headimg :src='admin.headimgurl'></headimg>
    <div class="darken-text ml-2 details-name">
      <div class="text-ellipsis">{{ admin.name }}</div>
      <div class="text-small light-gray-text text-ellipsis">{{ admin.identifier }}</div>
    </div>
  </div>
  <div class="darken-text ml-8">{{ admin.phone }}</div>
  <access-popover
    :accessesList="accessesList"
    :admin="admin"
    :access="access"
    @adminAccessChanged='adminAccessChangedFunc' />
  <span class="btn outlined btn-danger" @click="deleteSelectedMember(admin)">移除</span>
</div>`,
  methods: {
    deleteSelectedMember: function(admin) {
      return this.$emit('deleteSelectedMember', admin);
    },
    adminAccessChangedFunc: function(administration) {
      return this.$emit('adminAccessChanged', administration);
    }
  }
});
